import React from 'react';
import _ from 'lodash';

import {
    DefaultStrideIcon,
    Carrier_Truck,
    Driver,
    Location_Location,
    Route_Lane,
    Supplier_Supplier,
    Trailer_Equipment,
    Zone_Cold,
    MDM,
    MDM_Setup,
    Configuration,
    LoadAndTrip,
    Query,
    Create,
    Invoice,
    Finance,
    LoadBuilder,
    ShadowMode,
    Profile,
    ManualLoadPlanning,
    Releases,
    Requests,
    TripManagement,
    TransOrderManagement,
    WTMSStrideSync,
    Resources,
    DownloadCenter,
} from './Stride_Icons/index';

const StrideIcon = (props) => {
    const iconMap = {
        MDM: <MDM {...props} />,
        Carrier_Truck: <Carrier_Truck {...props} />,
        Configuration: <Configuration {...props} />,
        Driver: <Driver {...props} />,
        Location_Location: <Location_Location />,
        LoadAndTrip: <LoadAndTrip {...props} />,
        MDM_Setup: <MDM_Setup {...props} />,
        Query: <Query {...props} />,
        Create: <Create {...props} />,
        Route_Lane: <Route_Lane {...props} />,
        Supplier_Supplier: <Supplier_Supplier {...props} />,
        Trailer_Equipment: <Trailer_Equipment {...props} />,
        Invoice: <Invoice {...props} />,
        Zone_Cold: <Zone_Cold {...props} />,
        Finance: <Finance {...props} />,
        LoadBuilder: <LoadBuilder {...props} />,
        ManualLoadPlanning: <ManualLoadPlanning {...props} />,
        ShadowMode: <ShadowMode {...props} />,
        Profile: <Profile {...props} />,
        Releases: <Releases {...props} />,
        Requests: <Requests {...props} />,
        TripManagement: <TripManagement {...props} />,
        TransOrderManagement: <TransOrderManagement {...props} />,
        WTMSStrideSync: <WTMSStrideSync {...props} />,
        Resources: <Resources {...props} />,
        DownloadCenter: <DownloadCenter {...props} />,
        default: <DefaultStrideIcon {...props} />,
    };
    return _.get(iconMap, [props.name], !props.hidefallbackIcon ? iconMap.default : null);
};

export default StrideIcon;
